import React, { useEffect, useState } from 'react';
import { Loader } from 'neon-design-system';
import ArticlePreviewListUI from './ArticlePreviewListUI';
import { useGetArticleList } from '../hooks/use-get-article-list';

interface ArticleListProps {
	batchSize?: number;
	onDataLoaded?: (totalCount: number) => void;
	source: string;
	onlyMySubscriptions?: boolean;
	excludeMySubscriptions?: boolean;
	freeOnly?: boolean;
	limit?: number;
	showPagination?: boolean;
	displayArticleCount?: boolean;
}

const ArticleList = ({
	batchSize = 9,
	source,
	onlyMySubscriptions,
	excludeMySubscriptions,
	freeOnly,
	limit,
	onDataLoaded,
	showPagination,
	displayArticleCount = true
}: ArticleListProps) => {
	const [page, setPage] = useState(0);

	const {
		articles,
		loading,
		hasNextPage,
		fetchMore,
		totalCount
	} = useGetArticleList({
		batchSize,
		onlyMySubscriptions,
		excludeMySubscriptions,
		freeOnly,
		page
	});

	useEffect(() => {
		if (!loading && onDataLoaded) {
			onDataLoaded?.(totalCount ?? 0);
		}
	}, [totalCount, loading, onDataLoaded]);

	if (loading) return <Loader />;
	if (!articles?.length) return null;

	const limitedArticles = limit && articles.length >= limit
		? articles.slice(0, limit)
		: articles;

	const total = limit && totalCount
		? totalCount > limit
			? limit
			: totalCount
		: totalCount;

	const displayShowMoreButton: boolean = !limit || !!(limit && limitedArticles.length < limit);

	return (
		<ArticlePreviewListUI
			source={source}
			showPagination={showPagination}
			articles={limitedArticles}
			total={total}
			displayShowMoreButton={displayShowMoreButton}
			displayArticleCount={displayArticleCount}
			hasNextPage={!!hasNextPage}
			fetchMore={() => {
				fetchMore();
				setPage(page + 1)
			}}
		/>
	);
};

export default ArticleList;
